module.exports = __webpack_public_path__ + "static/media/sql.690b33c2.svg";